import { api } from 'services/rtk';
import type { ResponseOnlySuccess, ResponseWithSuccess } from 'services/rtk/common';

import type { FetchNotificationsResponse } from './types/api';

export const notificationsApi = api
  .enhanceEndpoints({
    addTagTypes: ['notifications'],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchNotifications: build.query<FetchNotificationsResponse, { page: number }>({
        query: (params) => ({
          url: '/notifications',
          params: {
            page: params.page,
            limit: 10,
          },
        }),
      }),
      checkUnreadNotifications: build.query<boolean, void>({
        query: () => ({
          url: '/notifications/hasUnread',
        }),
        transformResponse: (response: ResponseWithSuccess<{ hasUnread: boolean }>) => {
          return response.data.hasUnread;
        },
        providesTags: ['notifications'],
      }),
      readNotifications: build.mutation<ResponseOnlySuccess, { ids: number[] }>({
        query: (params) => ({
          method: 'POST',
          url: '/notifications/read',
          body: params,
        }),
        invalidatesTags: ['notifications'],
      }),
    }),
  });
